import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';

export const syncImosGuids = (
    imosRotation: RotationPortCall[],
    stowageRotation: RotationPortCall[],
    imosRotationCargoList: RotationCargo[],
    stowagePlanRotationCargoList: RotationCargo[]
) => {
    syncRotationGuids(imosRotation, stowageRotation);
    syncCargoGuids(imosRotationCargoList, stowagePlanRotationCargoList);
};

const syncRotationGuids = (imosRotation: RotationPortCall[], stowageRotation: RotationPortCall[]) => {
    if (!imosRotation || !stowageRotation) return;
    for (const imosPortCall of imosRotation) {
        const stowagePortCall = stowageRotation.find((pc) => pc.imosPortCallId === imosPortCall.imosPortCallId);
        if (stowagePortCall && imosPortCall.portCallGuid !== stowagePortCall.portCallGuid) {
            imosPortCall.portCallGuid = stowagePortCall.portCallGuid;
        }
        for (const berthCall of imosPortCall.berthCalls) {
            const stowageBerthCall = stowagePortCall?.berthCalls.find((bc) => bc.imosBerthCallId === berthCall.imosBerthCallId);
            if (stowageBerthCall && berthCall.berthCallGuid !== stowageBerthCall.berthCallGuid) {
                berthCall.berthCallGuid = stowageBerthCall.berthCallGuid;
            }
            if (stowagePortCall && berthCall.portCallGuid !== stowagePortCall.portCallGuid) {
                berthCall.portCallGuid = stowagePortCall.portCallGuid;
            }
            for (const cargoOperation of berthCall.cargoOperations) {
                const stowageCargoOperation = stowageBerthCall?.cargoOperations.find(
                    (co) => co.imosCargoOperationId === cargoOperation.imosCargoOperationId
                );
                if (stowageCargoOperation && cargoOperation.cargoOperationGuid !== stowageCargoOperation.cargoOperationGuid) {
                    cargoOperation.cargoOperationGuid = stowageCargoOperation.cargoOperationGuid;
                }
                if (stowageBerthCall && cargoOperation.berthCallGuid !== stowageBerthCall.berthCallGuid) {
                    cargoOperation.berthCallGuid = stowageBerthCall.berthCallGuid;
                }
                if (stowagePortCall && cargoOperation.portCallGuid !== stowagePortCall.portCallGuid) {
                    cargoOperation.portCallGuid = stowagePortCall.portCallGuid;
                }

                if (cargoOperation.cargoGuid !== cargoOperation.cargo?.cargoGuid) {
                    cargoOperation.cargoGuid = cargoOperation.cargo?.cargoGuid;
                }
            }
        }
    }
};

const syncCargoGuids = (imosRotationCargoList: RotationCargo[], stowagePlanRotationCargoList: RotationCargo[]) => {
    if (!imosRotationCargoList || !stowagePlanRotationCargoList) return;
    for (const imosCargo of imosRotationCargoList) {
        const stowageCargo = stowagePlanRotationCargoList.find((c) => c.imosCargoId === imosCargo.imosCargoId);
        if (stowageCargo && imosCargo.cargoGuid !== stowageCargo.cargoGuid) {
            imosCargo.cargoGuid = stowageCargo.cargoGuid;
        }
    }
};
